import { render } from "./ModuleMenuV2.vue?vue&type=template&id=5af9578a&scoped=true"
import script from "./ModuleMenuV2.vue?vue&type=script&lang=js"
export * from "./ModuleMenuV2.vue?vue&type=script&lang=js"

import "./ModuleMenuV2.vue?vue&type=style&index=0&id=5af9578a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af9578a"]])

export default __exports__